import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { RichText } from "tsi-common-react/src/components/RichText/index";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import iconSpeechBubblesTalk from "../../../assets/svg/speech-bubbles-talk.svg";

import helpStyles from "../../../styles/composable/basket-summary-help.module.scss";

export const CheckoutSidebarContent = (): React.ReactNode => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const enableCheckoutSidebarQuestionsBlock = usePageSetting(
        "enable_checkout_sidebar_questions_block",
    );
    const checkoutSidebarExtraContent = usePageSetting(
        "checkout_sidebar_extra_content",
    );
    let questionsBlock: JSX.Element | null = null;
    // TODO(i18n): LOW - Setting key should use a more descriptive name, but this is acceptable as a technical identifier
    if (enableCheckoutSidebarQuestionsBlock) {
        questionsBlock = (
            <div className={helpStyles.basketSummaryHelp}>
                <h3>
                    <SVG
                        className={helpStyles.basketSummaryHelpIcon}
                        src={iconSpeechBubblesTalk}
                        // TODO(i18n): MEDIUM - Icon title should be more descriptive for screen readers: t`Questions Icon` or t`Help Icon`
                        title={t`Speech Bubbles Icon`}
                    />
                    {t`Questions?`}
                </h3>
                <div className={helpStyles.basketSummaryText}>
                    <ChatLink
                        className={concatClassNames([
                            helpStyles.basketSummaryHelpLink,
                            helpStyles.basketSummaryHelpLinkCheckout,
                        ])}
                        chatOfflineLink={contactURL || homeURL}
                    />
                    <br />
                </div>
            </div>
        );
    }
    return (
        <div className={helpStyles.basketSummarySidebarContent}>
            {questionsBlock}
            {/* TODO(i18n): MEDIUM - Verify that checkout-sidebar-extra-content setting contains pre-translated HTML or uses RichText translation */}
            <RichText html={checkoutSidebarExtraContent || ""} />
        </div>
    );
};
